const SEGMENTS_HASH_CLIENT = 3;

export function estHashPortailClient(hash) {
  try {
    const contenu = atob(hash.replace(/ /g, '+'));
    return contenu.split('|').length >= SEGMENTS_HASH_CLIENT;
  } catch (e) {
    return false;
  }
}
